import React from "react";
import { typography } from "shared";
import styles from "./Service.styles";

interface Props {
	image: string;
	title: string;
	descriptionList: string[];
}

export const Service: React.FC<Props> = ({ image, title, descriptionList }) => {
	return (
		<div css={styles.container}>
			<div css={styles.image}>
				<img src={image} height={400} width={400} alt={title} loading="eager" />
			</div>
			<h1 css={styles.title}>{title}</h1>
			<div css={styles.metadata}>
				{descriptionList.map((description) => (
					<p key={description} css={typography.body2}>
						{description}
					</p>
				))}
			</div>
		</div>
	);
};
